import { Component, Input, OnInit } from '@angular/core';
import { IUserSessionData } from '../../../store/models/user.model';
import { faExclamationTriangle } from '@fortawesome/free-solid-svg-icons';

@Component({
  selector: 'app-confirmed-at',
  templateUrl: './confirmed-at.component.html',
  styleUrls: ['./confirmed-at.component.scss']
})
export class ConfirmedAtComponent implements OnInit {

  @Input() confirmedAt: string;
  @Input() user: IUserSessionData

  warningIcon = faExclamationTriangle;

  constructor() { }

  ngOnInit(): void {
  }
}
